import axiosConfig from '../utils/axiosConfigInstance';

export const libraryApis = {
	/**
	 * Fetch single filtered videos.
	 */
	getSingleFilteredVideos: ({
		startIndex,
		endIndex,
		selectedTags = [],
		selectedDurations = [],
		selectedLevels = [],
		sortby = 'latest',
		selectedInstructors = [],
		selectedProducts = [],
		userId,
		categoryId
	}) =>
		axiosConfig.post(`${import.meta.env.VITE_APP_API_URL}/library/single/page/video`, {
			startIndex,
			endIndex,
			selectedTags: selectedTags,
			selectedDurations: selectedDurations,
			selectedLevels: selectedLevels,
			sortby,
			selectedInstructors,
			selectedProducts,
			userId,
			categoryId
		}),

	/**
	 * Fetch library videos with filters using URLSearchParams.append()
	 */
	getLibraryVideos: async data => {
		try {
			const { userId, vtags, durations, levels, instructors, products, sort_by } = data;
			const baseUrl = `${import.meta.env.VITE_APP_API_URL}/library/page/video`;
			const params = [];

			// Handle empty string or valid string values
			if (userId !== null) params.push(`userId=${userId}`);
			if (vtags) params.push(`vtags=${vtags}`);
			if (durations) params.push(`durations=${durations}`);
			if (levels) params.push(`levels=${levels}`);

			// Handle arrays - convert instructors array to comma-separated string
			if (instructors?.length) params.push(`instructors=${instructors.join(',')}`);
			if (products?.length) params.push(`products=${products.join(',')}`);

			// Always include sort_by
			params.push(`sort_by=${sort_by}`);

			// Construct final URL
			const queryString = params.length ? `?${params.join('&')}` : '';
			const finalUrl = `${baseUrl}${queryString}`;

			return await axiosConfig.get(finalUrl);
		} catch (error) {
			console.error('Error in getLibraryVideos:', error);
			throw error;
		}
	}
};
